import { api } from "@/lib/api";

const KEY = "nutriscan_prefs";
const DEFAULT = { language: null, diets: [], allergies: [], conditions: [] };

export const getLocalPrefs = () => {
  try {
    const p = { ...DEFAULT, ...(JSON.parse(localStorage.getItem(KEY)) || {}) };
    return { ...p, diets: (p.diets || []).filter((d) => d !== "child" && d !== "diabetes") };
  } catch {
    return { ...DEFAULT };
  }
};

export const savePrefs = async (prefs, isLoggedIn) => {
  const merged = { ...DEFAULT, ...prefs };
  localStorage.setItem(KEY, JSON.stringify(merged));
  if (isLoggedIn) await api.put("/me/preferences", merged);
  return merged;
};

// Проверка соответствия товара предпочтениям. Возвращает {conflicts:[], matches:[]}
export const evaluateProduct = (score, prefs, t) => {
  const conflicts = [];
  const matches = [];
  if (!score) return { conflicts, matches };
  const d = score.dietary || {};
  const certs = score.certificates || [];
  const diets = prefs.diets || [];
  const R = (k) => t(`rec.reasons.${k}`);

  const halalOk = certs.includes("halal");
  if (diets.includes("halal")) {
    if (halalOk) matches.push(t("diet.halal"));
    else {
      if (d.pork) conflicts.push(R("pork"));
      if (d.alcohol) conflicts.push(R("alcohol"));
      if (d.gelatin) conflicts.push(R("gelatin"));
    }
  }
  if (diets.includes("no_pork") && d.pork) conflicts.push(R("pork"));
  if (diets.includes("no_alcohol") && d.alcohol) conflicts.push(R("alcohol"));
  if (diets.includes("vegan")) {
    if (d.meat) conflicts.push(R("meat"));
    if (d.dairy) conflicts.push(R("dairy"));
    if (d.egg) conflicts.push(R("egg"));
    if (d.honey) conflicts.push(R("honey"));
  }
  if (diets.includes("vegetarian") && d.meat) conflicts.push(R("meat"));

  const allergies = (prefs.allergies || []).map((a) => a.toLowerCase().trim()).filter(Boolean);
  if (allergies.length) {
    const facts = [...(score.facts?.negatives || []), ...(score.facts?.positives || [])];
    const text = JSON.stringify(facts).toLowerCase();
    allergies.forEach((a) => {
      if (text.includes(a)) conflicts.push(`${R("allergen")}: ${a}`);
    });
  }
  return { conflicts: [...new Set(conflicts)], matches: [...new Set(matches)] };
};
